<template>
  <div class="item">
    <div class="buttons">
      <a @click="clickBackButton" class="back">
        <vk-icon icon="triangle-left" ratio="2"></vk-icon>
      </a>
      <span v-if="item">ID:{{ item.id | zeroPadding }}</span>
    </div>
    <div class="item-preview-container">
      <figure id="preview" :style="styleObject" :data-color="selectedColor.name">
        <svg class="preview-image"
             ref="svgContainer"
             preserveAspectRatio="xMinYMin meet"
             x="0px" y="0px" :width="widthPercent" :height="heightPercent"
             v-if="item" v-html="item.image"
             :class="{normal:direction===0,reverse:direction===1}"
             version="1.1" xmlns="http://www.w3.org/2000/svg" >
        </svg>
      </figure>
      <div class="favorites" @click="clickFavorite">
        <img class="up" v-if="!isFavorite" src="../assets/img/star_off.svg"/>
        <img class="up" v-if="isFavorite" src="../assets/img/star_on.svg"/>
      </div>
    </div>
    <div v-if="colors.length">
      <div class="color-name" :style="colorNameStyleObject">
        <span v-if="selectedColor">{{ selectedColor.name }}</span>
      </div>
      <InfinitySwipe class="colors" :loop="true" :currentPage="currentPage" :itemWidth="50"
              @move="slideMove"
              @touch-end="onTouchEnd"
              @change-page="onSlideChangePage">
        <div class="infinity-swipe-item" v-for="(color, index) in colors" :key="color.id">
          <button @click="onButtonClick(index+1)" :class="{active: color === selectedColor}">
            <span class="circle" v-if="color.color[0] !== '/'" :style="circleStyle(color)">
            {{ color.label }}
            </span>
            <span class="circle" v-else
                  :style="{'background-image': 'url(' + require('../assets' + color.color) + ')'}">
            </span>
          </button>
        </div>
      </InfinitySwipe>
    </div>
    <div class="position">
      <div>
        <label>左右反転</label>
        <div class="direction-buttons">
          <img src="../assets/img/yazirushi.svg" :class="{active:direction===0}" @click="direction=Number(!direction)"/>
        </div>
      </div>
      <div>
        <label>サイズ/長辺×短辺(@単価)</label>
        <br>
        <select class="form-control" v-model="selectedSizeIndex" style="width: 18rem; display: inline">
          <option v-for="(s,index) in size" :key="index" :value="index">{{ s.label }}
            (@{{ calcPrice(
            s.longSize,
            s.shortSize,
            item.image.length,
            selectedColor.color_type.price_factor,
            item.send_price
            ) | money }})
          </option>
        </select>
      </div>
    </div>
    <div class="addCart">
      <div>
        <select class="form-control" v-model="number" v-if="size">
          <option v-for="val in 50" :key="val" :value="val">{{ val }}枚 (
            {{ calcPrice(
            size[selectedSizeIndex].longSize,
            size[selectedSizeIndex].shortSize,
            item.image.length,
            selectedColor.color_type.price_factor,
            item.send_price
            ) * val | money }}
            )
          </option>
        </select>
      </div>
      <vk-button class="cart-button btn-danger" v-if="cartId>=0" @click="changeCart">変更完了</vk-button>
      <vk-button class="cart-button btn-danger" v-else           @click="addCart"   >カートに入れる</vk-button>
    </div>
    <vk-modal class="cart_modal" :show.sync="show" center>
      <vk-modal-title>{{modalMessage}}</vk-modal-title>
      <div slot="footer">
      <vk-button class="btn btn-secondary btn-block" @click="clickConfirmCart">カートを見る</vk-button>
      <vk-button class="btn btn-secondary btn-block" @click="show=false">デザインを続ける</vk-button>
      <vk-button class="btn btn-secondary btn-block" @click="clickContinue">一覧に戻る</vk-button>
      </div>
    </vk-modal>
    <ColorPattern :uniq_key="uniq_key"></ColorPattern>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import axios from 'axios';
  import InfinitySwipe from 'vue-swipe-menu';
  import 'vue-swipe-menu/dist/vue-swipe-menu.css'
  import VkIcon from 'vuikit/src/library/icon/components/icon';
  import ColorPattern from '@/components/ColorPattern.vue';


  export default {
    name: 'Item',
    components: {
      VkIcon,
      InfinitySwipe,
      ColorPattern,
    },
    data() {
      return {
        show: false,
        modalMessage: '',
        direction: 0,
        touch_time: 0,
        item: null,
        height: null,
        width: null,
        aspect: null,
        number: '1',
        size: null,
        selectedSizeIndex: 0,
        selectedDirection: 'width',
        sizeDivisionAspect: 3.9,
        uniq_key: new Date().getTime().toString(16)  + Math.floor(1000 * Math.random()).toString(16),
        from: null,
      };
    },
    created() {
      this.initialize();
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        // `vm` を通じてコンポーネントインスタンスにアクセス
        vm.from = from;
      })
    },
    computed: {
      ...mapGetters(['items', 'colors', 'selectedColor']),
      page() {
        return this.$store.state.page;
      },
      loading() {
        return this.$store.state.loading;
      },
      currentPage() {
        if (!this.colors.length) return;
        return this.colors.indexOf(this.colors.find(color => color.id === this.selectedColor.id)) + 1;
      },
      styleObject() {
        if (!this.selectedColor) return;
        if (this.selectedColor.color[0] === '/') {
          let id = '#' + this.selectedColor.color.substr(5, 3) + '.' + this.uniq_key;
          return {
            fill: 'url(' + id + ')',
            stroke: '',
          };
        } else {
          return {
            fill: this.selectedColor.color,
            stroke: '',
          };
        }
      },
      colorNameStyleObject() {
        return {
          backgroundColor: this.selectedColor.color,
        };
      },
      svgStyle() {
        return {
          width: (this.width * 10) + 'px',
          height: (this.height * 10) + 'px',
        };
      },
      widthPercent() {
        let percent = Number(this.width) / this.sizeDivisionAspect;
        const heightPercent = Number(this.height) / this.sizeDivisionAspect;
        if (heightPercent >= 100) {
          percent = 100 / this.aspect;
        }
        percent = Math.min(100, percent);
        return `${percent}%`;
      },
      heightPercent() {
        let percent = Number(this.height) / this.sizeDivisionAspect;
        const widthPercent = Number(this.width) / this.sizeDivisionAspect;
        if (widthPercent >= 100) {
          percent = this.aspect * 100;
        }
        percent = Math.min(100, percent);
        return `${percent}%`;
      },
      sizeLabelStyle() {
        if (this.selectedDirection === 'height') {
          return 'size-height';
        } else {
          return 'size-width';
        }
      },
      isFavorite () {
        if (!this.item) return;
        return this.$store.state.favorites.indexOf(this.item.id) !== -1;
      },
      cartId () {
        return this.$route.query.cart;
      }
    },
    methods: {
      async initialize() {
        if (this.colors.length === 0) this.get_colors();
        const cartKey = Number(this.$route.query.cart);
        if (this.$store.state.cart[cartKey]) {         // カートからアイテム編集
          const cartItem = this.$store.state.cart[cartKey];
          this.$store.commit('setSelectedColor', cartItem.color);
          this.item = cartItem.item;
          this.$nextTick(() => {
            this.set_params();
            this.width = cartItem.width;
            this.height = cartItem.height;
          });
        } else {
          this.item = this.items.find(item => Number(item.id) === Number(this.$route.params.id));
          if (!this.item) {
            this.$store.commit('setLoading');
            const response = await axios.get('http://admin.harigu.com/api/items/' + this.$route.params.id);
            this.item = response.data;
            this.$store.commit('resetLoading');
            this.$nextTick(() => {
              this.set_params();
            });
          } else {
            this.$nextTick(() => {
              this.set_params();
            });
          }
        }
      },
      async get_colors () {
        const response = await axios.get('http://admin.harigu.com/api/colors');
        this.$store.commit('setColors', response.data);
      },
      set_params() {
        const bbox = this.$refs.svgContainer.getBBox();
        this.width = this.item.width;
        this.height = this.item.height;
        this.aspect = this.height / this.width;
        this.$refs.svgContainer.setAttribute(
          'viewBox', bbox.x + ', ' + bbox.y + ', ' + bbox.width + ', ' + bbox.height,
        );
        if (this.aspect > 1) {
          this.selectedDirection = 'height';
        } else {
          this.selectedDirection = 'width';
        }
        this.init_size();
      },
      init_size() {
        const min_size = this.item.min_size;
        const max_size = this.item.max_size;
        const step_size = 10;
        this.size = [];
        // 長辺の取得
        let longSide = (this.item.width > this.item.height) ? 'width' : 'height';
        let longSize = (longSide === 'width') ? this.width : this.height;
        let shortSize = (longSide === 'width') ? this.height : this.width;
        const shortAspect = longSize / shortSize;

        // リストの最初：最小長辺に合わせる
        longSize = min_size;
        shortSize = Math.round(longSize / shortAspect * 10) / 10;

        while (shortSize <= max_size) {
          this.size.push({
            longSize: longSize,
            shortSize: shortSize,
            width: (longSide === 'width') ? longSize : Math.round(longSize / shortAspect * 10) / 10,
            height: (longSide === 'height') ? longSize : Math.round(longSize / shortAspect * 10) / 10,
          });
          longSize += step_size;
          shortSize = Math.round(longSize / shortAspect * 10) / 10;
        }
        // 最大サイズが余りが出ているか
        if (longSize < max_size) {
          longSize = max_size;
          this.size.push({
            longSize: longSize,
            shortSize: Math.round(longSize / shortAspect * 10) / 10,
            width: (longSide === 'width') ? longSize : Math.round(longSize / shortAspect * 10) / 10,
            height: (longSide === 'height') ? longSize : Math.round(longSize / shortAspect * 10) / 10,
          });
        }
        this.getSelectedSizeIndex();
        this.setSizeLabel();
        // this.width = this.size[this.selectedSizeIndex].width;
        // this.height = this.size[this.selectedSizeIndex].height;
      },
      getSelectedSizeIndex () {
        for (let i = 0; i < this.size.length; i++) {
          if (this.item[this.selectedDirection] === this.size[i][this.selectedDirection]) {
            this.selectedSizeIndex = i;
          }
        }
      },
      setSizeLabel () {
        const size_format = size => (size / 10).toFixed(1);
        for (let i = 0; i < this.size.length; i++) {
          this.size[i].label = size_format(this.size[i].longSize) + 'cm×︎' + size_format(this.size[i].shortSize) + 'cm';
        }
      },
      getUniqueStr (myStrong) {
        var strong = 1000;
        if (myStrong) strong = myStrong;
        return new Date().getTime().toString(16) + Math.floor(strong * Math.random()).toString(16);
      },
      addCart () {
        const price = this.calcPrice(
          this.size[this.selectedSizeIndex].longSize,
          this.size[this.selectedSizeIndex].shortSize,
          this.item.image.length,
          this.selectedColor.color_type.price_factor,
          this.item.send_price,
        );

        let cart = {
          code: 'CT' + this.getUniqueStr(),
          item_id: Number(this.$route.params.id),
          width: Number(this.width),
          height: Number(this.height),
          number: Number(this.number),
          price: price,
          direction: this.direction,
          color: this.selectedColor,
          item: this.item,
          path: this.$route.path, // 戻り先を記憶
        };
        this.$store.commit('addCart', cart);
        this.modalMessage = 'カートに入れました';
        this.show = true;
      },
      changeCart () {
        const price = this.calcPrice(
          this.size[this.selectedSizeIndex].longSize,
          this.size[this.selectedSizeIndex].shortSize,
          this.item.image.length,
          this.selectedColor.color_type.price_factor,
          this.item.send_price,
        );
        let cart = {
          code: 'CT' + this.getUniqueStr(),
          item_id: Number(this.$route.params.id),
          width: Number(this.width),
          height: Number(this.height),
          number: Number(this.number),
          price: price,
          direction: this.direction,
          color: this.selectedColor,
          item: this.item,
        };
        // this.$store.dispatch('addCart', cart);
        this.$store.commit('changeCart', {cart:cart, index:this.cartId});
        // this.$store.commit('addMessage', '変更完了しました');
        this.modalMessage = '変更完了しました';
        this.show = true;
      },
      circleStyle (color) {
        return {
          backgroundColor: color.color,
          border: (color.color.toUpperCase() === '#FFFFFF') ? '1px solid black' : 'none',
          width: '38px',
          height: '38px',
        };
      },
      setPage (page) {
        if (page && this.colors.length) {
          this.$store.commit('setSelectedColor', this.colors[page - 1]);
        }
      },
      onButtonClick: function (page) {
        if (this.touch_time < 300) {
          this.onSlideChangePage(page);
        }
      },
      onSlideChangePage: function (page) {
        this.setPage(page);
      },
      slideMove: function (page) {
        if (page <= 0) page = 1;
        if (page > this.colors.length) page = this.colors.length + 1;
        if (this.colors[page - 1] !== undefined) {
          this.setPage(page);
        }
      },
      onTouchEnd: function (page, touchTime) {
        this.touch_time = touchTime;
      },
      clickFavorite() {
        if (this.isFavorite) {
          this.$store.dispatch('removeFavorite', this.item.id);
        } else {
          this.$store.dispatch('addFavorite', this.item.id);
        }
      },
      reverseSelectedDirection() {
        if (this.selectedDirection === 'width') {
          // this.selectedDirection = 'height';
          this.$set(this, 'selectedDirection', 'height');
        } else {
          // this.selectedDirection = 'width';
          this.$set(this, 'selectedDirection', 'width');
        }
        // this.$set(this, 'selectedDirection', (this.selectedDirection==='width' ? 'height' : 'width'));
      },
      clickConfirmCart() {
        this.show = false;
        // 完全に破棄してからページ遷移しないとモーダルがでなくなる
        setTimeout(() => {
          this.$router.push('/cart');
        }, 200);
      },
      clickContinue () {
        this.show = false;
        // 完全に破棄してからページ遷移しないとモーダルがでなくなる
        setTimeout(() => {
          this.$router.push('./');
        }, 200);
      },
      clickBackButton () {
        // window.console.log(this.from.name);
        if (this.from !== null && (
          this.from.name === 'popular' ||
          this.from.name === 'categoryCategory' ||
          this.from.name === 'search'
        )) {
          // window.console.log('back');
          this.$router.go(-1);
        } else {
          this.$router.push('./');
        }
      }
    },
    watch: {
      selectedSizeIndex(val) {
        this.width = this.size[val].width;
        this.height = this.size[val].height;
      },
      selectedDirection() {
        this.init_size();
      },
    },
  };
</script>

<style lang="scss" scoped>
  #preview {
     ::v-deep > svg {
      filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));
      transform: translate3d(0, 0, 0);
    }
  }
</style>

<style scoped lang="scss">
  label {
    margin-bottom: 0;
  }

  .buttons {
    position: sticky;
    top: 48px;
    background-color: rgb(128, 127, 128);
    color: #fff;
    font-weight: bold;
    overflow: hidden;
    z-index: 1;
    .back {
      color: rgb(240, 240, 240) !important;
      float: left;
      display: block;
    }
    span {
      float: right;
      display: block;
      padding-right: 10px;
      line-height: 40px;
    }
    &:after {
      clear: both;
    }
  }

  #preview {
    height: 395px;
    background-image: linear-gradient(
        transparent 95%,
        rgb(141, 245, 148) 5%
    ),
    linear-gradient(
        90deg,
        transparent 95%,
        rgb(141, 245, 148) 5%
    );
    background-size: 20px 20px;
    background-repeat: repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    overflow: hidden;

    .preview-image {
      max-width: inherit;
      transform-origin: center center;
      transition: all 1s ease;
      text-align: center;
      &.reverse {
        transform: scale(-1, 1);
      }
      ::v-deep svg {
        filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));
        transform: translate3d(0, 0, 0);
      }
    }
  }

  .item-preview-container {
    position: relative;

    .favorites {
      position: absolute;
      bottom: 0;
      right: 0;

      img {
        width: 4rem;
        height: 4rem;

        &.up {
        }

        &.down {
          transform: scale(-1, -1);
        }
      }
    }
  }

  .color-name {
    background-color: rgb(255, 55, 167);
    text-align: center;
    padding: 4px 0;
    line-height: 1rem;
    text-shadow: white 0px -1px 0px, white 0px 1px 0px, white 1px 0px 0px, white -1px 0px 0px;
  }

  .colors {
    width: 100%;
    overflow: hidden;

    button {
      border-bottom: 1px solid gray;
      background-color: #fff;
      color: #000;
      width: 50px;
      height: 50px;
      margin: 0;
      padding: 0;
      border-radius: 0;
      outline: none;
      border: 0;

      .circle {
        display: inline-block;
        border-radius: 20px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-size: contain;
      }
    }
  }

  .infinity-swipe-item {
    width: 50px;
    flex-shrink: 0;
    height: 100%;
  }

  .infinity-swipe-item > button.active {
    border-left: 1px solid gray;
    border-right: 1px solid gray;
  }

  .position {
    display: flex;
    background-color: rgb(128, 128, 128);
    justify-content: space-between;
    padding: 0px 5px 8px;

    & > div {
      flex-grow: 1;
      text-align: center;

      label {
        font-size: 11px;
        font-weight: bold;
      }
    }
  }

  .addCart {
    display: flex;
    justify-content: space-between;
    background-color: rgb(89, 89, 89);
    padding: 4px 10px;

    .cart-price {
      color: rgb(240, 240, 240);
      border: 0;
      border-radius: 1em;
      background-color: #000;
    }

    .cart-button {
      color: rgb(240, 240, 240);
      border-radius: .5em;
    }
  }

  .direction-buttons {
    img {
      height: calc(2.25rem + 2px);
      &.active {
        transform: scaleX(-1);
      }
    }
  }

  .size-height {
    margin-right: 0.2rem;
    transform-origin: 50%;
    transition: all .3s;
  }

  .size-width {
    margin-right: 0.4rem;
    transform-origin: 50%;
    transform: rotate(-90deg);
    transition: all .3s;
  }

  .cart_modal {
    .btn {
      width: 70%;
      margin: 1rem auto;
    }
  }
</style>
